export class Mask {
  static cpf(text) {
    return String(text).replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }
}
